export default __webpack_public_path__ + "static/ProximaNova-Semibold-227817852e96b494055e9b16561bedf9.otf";